// extracted by mini-css-extract-plugin
export default {"layout":"_040422369c fec659541a _816da3ab0e","h_slide":"cd01ec04cd","category":"d18452de82 _2fdf990ce6 _5bd158bb07"};